import React from 'react';
import {
  AppBar,
  Box,
  Container,
  Fab,
  makeStyles,
  Toolbar,
  Typography
} from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#1a1a1a', // Mobilde göz yormayan koyu mod
    minHeight: '100vh',
    padding: 0 // Mobil ekranı tam kullanmak için
  },
  header: {
    backgroundColor: 'rgba(33, 33, 33, 0.9)',
    backdropFilter: 'blur(8px)',
    color: '#fff',
    position: 'sticky',
    top: 0,
    zIndex: 1100
  },
  viewerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(8) // FAB butonu için boşluk
  },
  pageContainer: {
    width: '100%',
    marginBottom: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: 4,
    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
    position: 'relative',
    overflow: 'hidden'
  },
  guideImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
    // Resimlerin yüklenirken alanı tutması için (Layout Shift engelleme)
    aspectRatio: '1 / 1.414', // A4 dikey oranı
  },
  floatingBadge: {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: 'rgba(0,0,0,0.6)',
    color: '#fff',
    padding: '2px 8px',
    borderRadius: 12,
    fontSize: '0.65rem',
    fontWeight: 'bold'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: '#fff'
  }
}));

const items = Array.from(Array(52), (_, i) => i + 1);

function Overview() {
  const classes = useStyles();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Page className={classes.root} title="Kullanım Kılavuzu">
      {/* Mobil Üst Bar */}
      <AppBar className={classes.header} elevation={0}>
        <Toolbar variant="dense">
          <Typography variant="h6" style={{ flexGrow: 1, fontSize: '1rem' }}>
            Artemis Kılavuz
          </Typography>
          <Typography variant="caption">
            52 Sayfa
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm" className={classes.viewerContainer}>
        {items.map((item, index) => (
          <Box key={index} className={classes.pageContainer}>
            {/* Sayfa Numarası Rozeti */}
            <div className={classes.floatingBadge}>
              {item} / 52
            </div>
            
            <img
              src={`/kılavuz/KullanımKılavuzu-${item}.svg`}
              className={classes.guideImage}
              alt={`Sayfa ${item}`}
              loading="lazy"
              decoding="async" // Tarayıcıyı kilitlemeden görseli çöz
            />
          </Box>
        ))}
      </Container>

      {/* Başa Dön Butonu (Mobil Kolaylık) */}
      <Fab 
        size="small" 
        className={classes.fab} 
        onClick={scrollToTop}
        aria-label="top"
      >
        <ArrowUpwardIcon />
      </Fab>
    </Page>
  );
}

export default Overview;